module.exports = __webpack_public_path__ + "img/TX.6bea7ec7.png";